import { colors } from '@noths/polaris-client-ribbons-design-system';
import { pxToRem, responsiveFontSize, stack, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { getIconPath } from 'src/utils';

const CHECK_MARK_ICON = getIconPath('icons-16-checkmark.svg');

const { fonts, spacing, text } = theme;

export const button = css`
  border-radius: ${pxToRem(10)};
  border: solid 1px ${colors.neutralLight};
  margin: ${stack(spacing.xs)};
  padding: ${pxToRem(14)} ${pxToRem(spacing.sm)};
  width: 100%;
  background: ${colors.neutralWhite};
  color: ${colors.neutralDarker};
  font-family: ${fonts.PRIMARY_REGULAR.family};
  ${responsiveFontSize(text.xxs)};
  text-align: left;
  transition: border-color 0.15s ease-in, background-color 0.15s ease-in;
  position: relative;
  cursor: pointer;

  &:hover {
    border-color: ${colors.neutralDark};
  }

  &[aria-pressed='true'] {
    border-color: ${colors.brandBluePrimary};

    &:not(.focus-visible) {
      box-shadow: 0 0 ${pxToRem(8)} 0 rgba(0, 0, 0, 0.2);
    }
  }
`;

export const innerButtonWrapper = css`
  ${/*
    Safari <= 12 does not like setting grid on buttons and fieldsets.
    So, this had to be moved into an inner button span element. */
  ''}
  display: grid;
  grid-template-columns: 2fr 1fr;
`;

const CHECK_MARK_TRANSITION_TIME = '0.25s';

export const label = css`
  display: block;
  padding-right: ${pxToRem(32)};
  position: relative;
  transition: padding-left ${CHECK_MARK_TRANSITION_TIME},
    padding-right ${CHECK_MARK_TRANSITION_TIME};

  &::before {
    background: url(${CHECK_MARK_ICON}) 0 0 no-repeat;
    content: '';
    opacity: 0;
    position: absolute;
    left: ${pxToRem(4)};
    top: ${pxToRem(2)};
    height: ${pxToRem(16)};
    width: ${pxToRem(16)};
    transition: opacity ${CHECK_MARK_TRANSITION_TIME};
  }

  &[data-is-selected='true'] {
    padding-left: ${pxToRem(32)};
    padding-right: 0;

    &::before {
      opacity: 1;
    }
  }
`;

export const priceModifier = css`
  justify-self: flex-end;
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const priceOperator = css`
  font-size: ${pxToRem(text.xs.SMALL.fontSize)};
  justify-self: flex-end;
  margin-right: ${pxToRem(2)};

  &[data-is-negative='false'] {
    font-size: ${pxToRem(text.md.SMALL.fontSize)};
  }
`;
